import { defineComponent, computed, ref, createElementBlock, openBlock, createCommentVNode, createElementVNode, Fragment, toDisplayString, createTextVNode, unref, renderList, normalizeClass, createBlock } from "vue";
import { dateFormatter, vatExemptNote, Money, PaymentTypeLabel, PaymentAdditionLabel } from "app-core";
import { useI18n } from "vue-i18n";
import { useUtilities } from "./index52.js";
import _sfc_main$1 from "./index105.js";
const _hoisted_1 = { class: "receipt-einvoice printable-area" };
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = {
  key: 1,
  class: "receipt-header"
};
const _hoisted_4 = { class: "nonfiscal-heading" };
const _hoisted_5 = { class: "heading-numbers" };
const _hoisted_6 = { key: 0 };
const _hoisted_7 = { key: 1 };
const _hoisted_8 = { key: 2 };
const _hoisted_9 = { class: "heading-dates" };
const _hoisted_10 = { key: 0 };
const _hoisted_11 = { key: 1 };
const _hoisted_12 = { key: 2 };
const _hoisted_13 = { key: 3 };
const _hoisted_14 = { class: "receipt-subheader" };
const _hoisted_15 = { class: "receipt-details" };
const _hoisted_16 = { key: 0 };
const _hoisted_17 = { key: 1 };
const _hoisted_18 = { key: 2 };
const _hoisted_19 = { key: 3 };
const _hoisted_20 = { key: 4 };
const _hoisted_21 = { key: 5 };
const _hoisted_22 = {
  key: 0,
  class: "receipt-buyer"
};
const _hoisted_23 = { key: 0 };
const _hoisted_24 = { key: 1 };
const _hoisted_25 = { key: 0 };
const _hoisted_26 = { key: 1 };
const _hoisted_27 = { key: 2 };
const _hoisted_28 = { key: 3 };
const _hoisted_29 = { key: 4 };
const _hoisted_30 = { key: 5 };
const _hoisted_31 = {
  key: 1,
  class: "receipt-items"
};
const _hoisted_32 = { class: "heading-row" };
const _hoisted_33 = { align: "left" };
const _hoisted_34 = { align: "left" };
const _hoisted_35 = { align: "left" };
const _hoisted_36 = { align: "right" };
const _hoisted_37 = { align: "right" };
const _hoisted_38 = { align: "right" };
const _hoisted_39 = { align: "left" };
const _hoisted_40 = { align: "left" };
const _hoisted_41 = {
  align: "left",
  class: "name"
};
const _hoisted_42 = { key: 0 };
const _hoisted_43 = { key: 1 };
const _hoisted_44 = ["innerHTML"];
const _hoisted_45 = {
  key: 3,
  style: { "font-size": "11px" }
};
const _hoisted_46 = { align: "right" };
const _hoisted_47 = { align: "right" };
const _hoisted_48 = { align: "right" };
const _hoisted_49 = {
  key: 2,
  class: "receipt-items"
};
const _hoisted_50 = { class: "heading-row" };
const _hoisted_51 = { align: "left" };
const _hoisted_52 = { align: "left" };
const _hoisted_53 = { align: "left" };
const _hoisted_54 = { align: "right" };
const _hoisted_55 = { align: "right" };
const _hoisted_56 = { align: "right" };
const _hoisted_57 = { align: "right" };
const _hoisted_58 = { align: "right" };
const _hoisted_59 = { align: "right" };
const _hoisted_60 = { align: "right" };
const _hoisted_61 = { align: "right" };
const _hoisted_62 = { align: "right" };
const _hoisted_63 = { align: "left" };
const _hoisted_64 = { align: "left" };
const _hoisted_65 = {
  align: "left",
  class: "name"
};
const _hoisted_66 = { key: 0 };
const _hoisted_67 = { key: 1 };
const _hoisted_68 = {
  key: 2,
  style: { "font-size": "11px" }
};
const _hoisted_69 = { align: "right" };
const _hoisted_70 = { align: "right" };
const _hoisted_71 = { align: "right" };
const _hoisted_72 = { align: "right" };
const _hoisted_73 = { align: "right" };
const _hoisted_74 = { align: "right" };
const _hoisted_75 = { align: "right" };
const _hoisted_76 = { align: "right" };
const _hoisted_77 = { align: "right" };
const _hoisted_78 = { colspan: "10" };
const _hoisted_79 = ["innerHTML"];
const _hoisted_80 = { class: "receipt-footer" };
const _hoisted_81 = { class: "footer-item additional-info" };
const _hoisted_82 = {
  key: 0,
  class: "mt-2"
};
const _hoisted_83 = {
  key: 0,
  class: "note"
};
const _hoisted_84 = {
  key: 1,
  class: "note"
};
const _hoisted_85 = { class: "signatures" };
const _hoisted_86 = { class: "signature" };
const _hoisted_87 = { class: "signature" };
const _hoisted_88 = { class: "footer-item summary" };
const _hoisted_89 = {
  key: 0,
  class: "summary-item to-pay"
};
const _hoisted_90 = { class: "amount" };
const _hoisted_91 = {
  key: 1,
  class: "summary-item to-pay"
};
const _hoisted_92 = { class: "amount" };
const _hoisted_93 = { class: "amount" };
const _hoisted_94 = { class: "tax-items" };
const _hoisted_95 = { class: "heading-row" };
const _hoisted_96 = { align: "left" };
const _hoisted_97 = { align: "center" };
const _hoisted_98 = { align: "right" };
const _hoisted_99 = { align: "right" };
const _hoisted_100 = { align: "left" };
const _hoisted_101 = { align: "center" };
const _hoisted_102 = { align: "right" };
const _hoisted_103 = { align: "right" };
const _hoisted_104 = {
  key: 0,
  class: "bordered"
};
const _hoisted_105 = { colspan: "3" };
const _hoisted_106 = { align: "right" };
const _hoisted_107 = { class: "bordered" };
const _hoisted_108 = { colspan: "3" };
const _hoisted_109 = { align: "right" };
const priceFormat = "0,0.00";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ReceiptInvoiceManual",
  props: {
    order: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      default: () => {
      }
    },
    venue: {
      type: Object,
      default: () => void 0
    },
    isRetail: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const { t } = useI18n();
    const { formatDate, formatDateTime } = dateFormatter();
    const { nl2br } = useUtilities();
    const props = __props;
    const vatNote = computed(() => props.order.isIncoming() ? null : vatExemptNote(props.venue, `${t("general.note")}: ${t("order.exempt_from_tax_comment")}`));
    const requestsPayment = !props.order.isIncoming();
    const client = ref(props.order.getClient() || props.order.client || null);
    const paymentTypes = ref(getPaymentTypes());
    function getPaymentTypes() {
      const totalPaid = props.order.getPaid().abs();
      const totalAmount = props.order.getToPay().abs();
      const remaining = props.order.isAdvance() ? Money.parse(0) : Money.parse(totalAmount.toRoundedUnit(2)).subtract(Money.parse(totalPaid.toRoundedUnit(2)));
      let allPaymentTypes = [];
      let paymentTypes2 = props.order.getPayments();
      const advancePayment = paymentTypes2.find((p) => p.key === PaymentTypeLabel.advance);
      if (advancePayment) {
        allPaymentTypes.push(advancePayment);
        paymentTypes2 = paymentTypes2.filter((p) => p.key !== PaymentTypeLabel.advance);
      }
      allPaymentTypes = [
        ...allPaymentTypes,
        ...paymentTypes2.filter((p) => p.key !== PaymentTypeLabel.advance)
      ];
      if (remaining.toUnit() !== 0) {
        allPaymentTypes.push({
          key: PaymentAdditionLabel.change,
          display: remaining.toUnit() < 0 ? t("receipt.payments.change") : t("receipt.payments.left_to_pay"),
          amount: remaining.abs().toUnit()
        });
      }
      return allPaymentTypes;
    }
    const summary = ref(getSummary());
    function getSummary() {
      const totalAmount = props.order.getToPay().abs();
      const totalTax = props.order.getTax().abs();
      const totalPriceBeforeTax = props.order.getPriceBeforeTax().abs();
      return {
        totalAmount,
        totalTax,
        totalPriceBeforeTax
      };
    }
    return (_ctx, _cache) => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t;
      return openBlock(), createElementBlock("div", _hoisted_1, [
        !__props.order.isIncoming() ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          ((_a = __props.venue) == null ? void 0 : _a.invoice_header) ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: "ck-content ck-custom",
            innerHTML: (_b = __props.venue) == null ? void 0 : _b.invoice_header
          }, null, 8, _hoisted_2)) : (openBlock(), createElementBlock("div", _hoisted_3, [
            createElementVNode("p", null, toDisplayString((_c = __props.venue) == null ? void 0 : _c.company_name), 1),
            createElementVNode("p", null, toDisplayString((_d = __props.venue) == null ? void 0 : _d.name), 1),
            createElementVNode("p", null, toDisplayString((_e = __props.venue) == null ? void 0 : _e.address), 1)
          ]))
        ], 64)) : createCommentVNode("", true),
        createElementVNode("div", _hoisted_4, [
          createElementVNode("div", _hoisted_5, [
            __props.order.isProforma() || __props.order.isEinvoice() || __props.order.isAdvance() ? (openBlock(), createElementBlock("p", _hoisted_6, [
              createElementVNode("strong", null, [
                __props.order.isProforma() ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                  createTextVNode(toDisplayString(unref(t)("general.receipt_type") + ": " + unref(t)("general.proforma", 1)), 1)
                ], 64)) : __props.order.isEinvoice() ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                  createTextVNode(toDisplayString(unref(t)("general.receipt_type") + ": " + unref(t)("general.einvoice", 1)), 1)
                ], 64)) : createCommentVNode("", true),
                __props.order.isAdvance() ? (openBlock(), createElementBlock(Fragment, { key: 2 }, [
                  createTextVNode(toDisplayString(" / " + unref(t)("general.advance")), 1)
                ], 64)) : createCommentVNode("", true),
                __props.order.isEinvoice() && __props.order.register_status ? (openBlock(), createElementBlock(Fragment, { key: 3 }, [
                  createTextVNode(toDisplayString("(" + unref(t)(`order.register_status.einvoice.${__props.order.register_status}`) + ")"), 1)
                ], 64)) : createCommentVNode("", true)
              ])
            ])) : createCommentVNode("", true),
            __props.order.number ? (openBlock(), createElementBlock("p", _hoisted_7, toDisplayString(unref(t)("receipt.serial_number") + ": " + __props.order.number), 1)) : createCommentVNode("", true),
            __props.order.internal_number ? (openBlock(), createElementBlock("p", _hoisted_8, toDisplayString(`${__props.order.isIncoming() ? unref(t)("receipt.supplier_invoice_number") : !__props.order.isProforma() ? unref(t)("receipt.internal_number") : unref(t)("receipt.proforma_number")}: ${__props.order.internal_number}`), 1)) : createCommentVNode("", true)
          ]),
          createElementVNode("div", _hoisted_9, [
            __props.order.getLastActivityAt() ? (openBlock(), createElementBlock("p", _hoisted_10, toDisplayString(unref(t)("general.issued_at") + ": ") + " " + toDisplayString(__props.order.isIncoming() ? unref(formatDate)(__props.order.getLastActivityAt()) : unref(formatDateTime)(__props.order.getLastActivityAt())), 1)) : createCommentVNode("", true),
            !__props.order.isIncoming() && __props.order.getTransactionDate() ? (openBlock(), createElementBlock("p", _hoisted_11, toDisplayString(unref(t)("general.transaction_date") + ": ") + " " + toDisplayString(unref(formatDate)(__props.order.getTransactionDate())), 1)) : createCommentVNode("", true),
            __props.order.due_date ? (openBlock(), createElementBlock("p", _hoisted_12, toDisplayString(!__props.order.isAdvance() ? unref(t)("receipt.due_date") : unref(t)("general.paid_date_advance")) + ": " + toDisplayString(unref(formatDate)(__props.order.due_date)), 1)) : createCommentVNode("", true),
            __props.order.start_date && __props.order.end_date ? (openBlock(), createElementBlock("p", _hoisted_13, toDisplayString(unref(t)("receipt.period")) + ": " + toDisplayString(unref(formatDate)(__props.order.start_date)) + " - " + toDisplayString(unref(formatDate)(__props.order.end_date)), 1)) : createCommentVNode("", true)
          ])
        ]),
        createElementVNode("div", _hoisted_14, [
          createElementVNode("div", _hoisted_15, [
            ((_f = __props.venue) == null ? void 0 : _f.company_name) ? (openBlock(), createElementBlock("p", _hoisted_16, toDisplayString(unref(t)("receipt.company")) + ": " + toDisplayString((_g = __props.venue) == null ? void 0 : _g.company_name), 1)) : createCommentVNode("", true),
            ((_h = __props.venue) == null ? void 0 : _h.tax_id_number) ? (openBlock(), createElementBlock("p", _hoisted_17, toDisplayString(unref(t)("receipt.tax_id_number")) + ": " + toDisplayString((_i = __props.venue) == null ? void 0 : _i.tax_id_number), 1)) : createCommentVNode("", true),
            ((_j = __props.venue) == null ? void 0 : _j.registration_number) ? (openBlock(), createElementBlock("p", _hoisted_18, toDisplayString(unref(t)("receipt.registration_number")) + ": " + toDisplayString((_k = __props.venue) == null ? void 0 : _k.registration_number), 1)) : createCommentVNode("", true),
            ((_l = __props.venue) == null ? void 0 : _l.name) ? (openBlock(), createElementBlock("p", _hoisted_19, toDisplayString(unref(t)("receipt.venue")) + ": " + toDisplayString((_m = __props.venue) == null ? void 0 : _m.name), 1)) : createCommentVNode("", true),
            ((_n = __props.venue) == null ? void 0 : _n.address) ? (openBlock(), createElementBlock("p", _hoisted_20, toDisplayString(unref(t)("receipt.address")) + ": " + toDisplayString((_o = __props.venue) == null ? void 0 : _o.address), 1)) : createCommentVNode("", true),
            ((_p = __props.venue) == null ? void 0 : _p.city) ? (openBlock(), createElementBlock("p", _hoisted_21, toDisplayString(unref(t)("receipt.municipality")) + ": " + toDisplayString((_q = __props.venue) == null ? void 0 : _q.city), 1)) : createCommentVNode("", true)
          ]),
          client.value ? (openBlock(), createElementBlock("div", _hoisted_22, [
            createElementVNode("p", null, [
              !__props.order.isIncoming() ? (openBlock(), createElementBlock("strong", _hoisted_23, toDisplayString(unref(t)("receipt.buyer")), 1)) : (openBlock(), createElementBlock("strong", _hoisted_24, toDisplayString(unref(t)("general.supplier", 1)), 1))
            ]),
            client.value.name ? (openBlock(), createElementBlock("p", _hoisted_25, toDisplayString(client.value.name), 1)) : createCommentVNode("", true),
            client.value.address ? (openBlock(), createElementBlock("p", _hoisted_26, [
              createTextVNode(toDisplayString(`${client.value.address}`) + " ", 1),
              client.value.city ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                createTextVNode(", " + toDisplayString(`${client.value.city}`), 1)
              ], 64)) : createCommentVNode("", true),
              client.value.country ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                createTextVNode(", " + toDisplayString(`${client.value.country}`), 1)
              ], 64)) : createCommentVNode("", true)
            ])) : createCommentVNode("", true),
            client.value.getTaxIdNumber() ? (openBlock(), createElementBlock("p", _hoisted_27, toDisplayString(unref(t)("receipt.buyer_tax_id_number") + ": " + client.value.getTaxIdNumber()), 1)) : createCommentVNode("", true),
            client.value.id_type === "tax_id_number_local_jbkjs" && ((_r = client.value.id_number) == null ? void 0 : _r.includes(":")) ? (openBlock(), createElementBlock("p", _hoisted_28, toDisplayString("JBKJS: " + client.value.id_number.split(":")[1]), 1)) : createCommentVNode("", true),
            client.value.cost_center ? (openBlock(), createElementBlock("p", _hoisted_29, toDisplayString(unref(t)("receipt.buyer_cost_center") + ": " + client.value.cost_center), 1)) : createCommentVNode("", true),
            client.value.registration_number ? (openBlock(), createElementBlock("p", _hoisted_30, toDisplayString(unref(t)("receipt.registration_number") + ": " + client.value.registration_number), 1)) : createCommentVNode("", true)
          ])) : createCommentVNode("", true)
        ]),
        !((_s = __props.venue) == null ? void 0 : _s.wholesale) ? (openBlock(), createElementBlock("table", _hoisted_31, [
          createElementVNode("tbody", null, [
            createElementVNode("tr", _hoisted_32, [
              createElementVNode("td", _hoisted_33, toDisplayString(unref(t)("receipt.items.number")), 1),
              createElementVNode("td", _hoisted_34, toDisplayString(unref(t)("receipt.items.code")), 1),
              createElementVNode("td", _hoisted_35, toDisplayString(unref(t)("receipt.items.name")), 1),
              createElementVNode("td", _hoisted_36, toDisplayString(unref(t)("receipt.items.unit_price")), 1),
              createElementVNode("td", _hoisted_37, toDisplayString(unref(t)("receipt.items.quantity")), 1),
              createElementVNode("td", _hoisted_38, toDisplayString(unref(t)("receipt.items.to_pay")), 1)
            ]),
            (openBlock(true), createElementBlock(Fragment, null, renderList(__props.order.items, (item, index) => {
              var _a2;
              return openBlock(), createElementBlock("tr", {
                key: `invoice-${index}`,
                class: normalizeClass({ "border-bottom": index !== __props.order.items.length - 1 })
              }, [
                createElementVNode("td", _hoisted_39, toDisplayString(index + 1) + ".", 1),
                createElementVNode("td", _hoisted_40, toDisplayString(((_a2 = item.getProduct()) == null ? void 0 : _a2.code) || ""), 1),
                createElementVNode("td", _hoisted_41, [
                  createElementVNode("span", null, toDisplayString(item.name), 1),
                  item.getTaxRateLabel() ? (openBlock(), createElementBlock("span", _hoisted_42, " (" + toDisplayString(item.getTaxRateLabel()) + ")", 1)) : createCommentVNode("", true),
                  item.getUnitOfMeasure() ? (openBlock(), createElementBlock("span", _hoisted_43, "/" + toDisplayString(item.getUnitOfMeasure()), 1)) : createCommentVNode("", true),
                  __props.isRetail && item.comments.length ? (openBlock(), createElementBlock("div", {
                    key: 2,
                    innerHTML: unref(nl2br)(item.comments[0])
                  }, null, 8, _hoisted_44)) : createCommentVNode("", true),
                  item.gtin ? (openBlock(), createElementBlock("div", _hoisted_45, "GTIN: " + toDisplayString(item.gtin), 1)) : createCommentVNode("", true)
                ]),
                createElementVNode("td", _hoisted_46, toDisplayString(item.getUnitPriceAfterDiscount().abs().toFormat(priceFormat)), 1),
                createElementVNode("td", _hoisted_47, toDisplayString(Math.abs(item.getCount())), 1),
                createElementVNode("td", _hoisted_48, toDisplayString(item.getToPay().toFormat(priceFormat)), 1)
              ], 2);
            }), 128)),
            _cache[0] || (_cache[0] = createElementVNode("tr", { class: "divider" }, [
              createElementVNode("td", { colspan: 12 })
            ], -1))
          ])
        ])) : (openBlock(), createElementBlock("table", _hoisted_49, [
          createElementVNode("tbody", null, [
            createElementVNode("tr", _hoisted_50, [
              createElementVNode("td", _hoisted_51, toDisplayString(unref(t)("receipt.items.number")), 1),
              createElementVNode("td", _hoisted_52, toDisplayString(unref(t)("receipt.items.code")), 1),
              createElementVNode("td", _hoisted_53, toDisplayString(unref(t)("receipt.items.name")), 1),
              createElementVNode("td", _hoisted_54, toDisplayString(unref(t)("receipt.items.quantity")), 1),
              createElementVNode("td", _hoisted_55, toDisplayString(unref(t)("receipt.items.wholesale.unit_price_before_tax")), 1),
              createElementVNode("td", _hoisted_56, toDisplayString(unref(t)("receipt.items.wholesale.tax_rate")), 1),
              createElementVNode("td", _hoisted_57, toDisplayString(unref(t)("receipt.items.wholesale.unit_price")), 1),
              createElementVNode("td", _hoisted_58, toDisplayString(unref(t)("receipt.items.wholesale.discount")), 1),
              createElementVNode("td", _hoisted_59, toDisplayString(unref(t)("receipt.items.wholesale.unit_price_after_discount")), 1),
              createElementVNode("td", _hoisted_60, toDisplayString(unref(t)("receipt.items.wholesale.price_before_tax")), 1),
              createElementVNode("td", _hoisted_61, toDisplayString(unref(t)("receipt.items.wholesale.tax")), 1),
              createElementVNode("td", _hoisted_62, toDisplayString(unref(t)("receipt.items.wholesale.to_pay")), 1)
            ]),
            (openBlock(true), createElementBlock(Fragment, null, renderList(__props.order.items, (item, index) => {
              var _a2, _b2;
              return openBlock(), createElementBlock(Fragment, {
                key: `invoice-${index}`
              }, [
                createElementVNode("tr", {
                  class: normalizeClass({ "border-bottom": (!__props.isRetail || !item.comments.length) && index != __props.order.items.length - 1 })
                }, [
                  createElementVNode("td", _hoisted_63, toDisplayString(index + 1) + ".", 1),
                  createElementVNode("td", _hoisted_64, toDisplayString(((_a2 = item.getProduct()) == null ? void 0 : _a2.code) || ""), 1),
                  createElementVNode("td", _hoisted_65, [
                    createElementVNode("span", null, toDisplayString(item.name), 1),
                    item.getTaxRateLabel() ? (openBlock(), createElementBlock("span", _hoisted_66, " (" + toDisplayString(item.getTaxRateLabel()) + ")", 1)) : createCommentVNode("", true),
                    item.getProduct() ? (openBlock(), createElementBlock("span", _hoisted_67, "/" + toDisplayString(((_b2 = item.getProduct()) == null ? void 0 : _b2.getUnitOfMeasureSold()) || ""), 1)) : createCommentVNode("", true),
                    item.gtin ? (openBlock(), createElementBlock("div", _hoisted_68, "GTIN: " + toDisplayString(item.gtin), 1)) : createCommentVNode("", true)
                  ]),
                  createElementVNode("td", _hoisted_69, toDisplayString(Math.abs(item.getCount())), 1),
                  createElementVNode("td", _hoisted_70, toDisplayString(item.getUnitPriceBeforeTax().toFormat("0.0000")), 1),
                  createElementVNode("td", _hoisted_71, toDisplayString(item.getTaxRate()) + "%", 1),
                  createElementVNode("td", _hoisted_72, toDisplayString(item.getUnitPriceAfterTax().toFormat(priceFormat)), 1),
                  createElementVNode("td", _hoisted_73, toDisplayString(item.getDiscountPercent()) + "%", 1),
                  createElementVNode("td", _hoisted_74, toDisplayString(item.getUnitPriceAfterDiscount().abs().toFormat(priceFormat)), 1),
                  createElementVNode("td", _hoisted_75, toDisplayString(item.getPriceBeforeTax().toFormat(priceFormat)), 1),
                  createElementVNode("td", _hoisted_76, toDisplayString(item.getTax().toFormat(priceFormat)), 1),
                  createElementVNode("td", _hoisted_77, toDisplayString(item.getToPay().toFormat(priceFormat)), 1)
                ], 2),
                __props.isRetail && item.comments.length ? (openBlock(), createElementBlock("tr", {
                  key: 0,
                  class: normalizeClass({ "border-bottom": index != __props.order.items.length - 1 })
                }, [
                  _cache[1] || (_cache[1] = createElementVNode("td", null, null, -1)),
                  _cache[2] || (_cache[2] = createElementVNode("td", null, null, -1)),
                  createElementVNode("td", _hoisted_78, [
                    createElementVNode("span", {
                      style: { "font-size": "11px" },
                      innerHTML: unref(nl2br)(item.comments[0])
                    }, null, 8, _hoisted_79)
                  ])
                ], 2)) : createCommentVNode("", true)
              ], 64);
            }), 128)),
            _cache[3] || (_cache[3] = createElementVNode("tr", { class: "divider" }, [
              createElementVNode("td", { colspan: 12 })
            ], -1))
          ])
        ])),
        createElementVNode("div", _hoisted_80, [
          createElementVNode("div", _hoisted_81, [
            __props.order.note || vatNote.value ? (openBlock(), createElementBlock("div", _hoisted_82, [
              __props.order.note ? (openBlock(), createElementBlock("p", _hoisted_83, toDisplayString(__props.order.note), 1)) : createCommentVNode("", true),
              vatNote.value ? (openBlock(), createElementBlock("p", _hoisted_84, toDisplayString(vatNote.value), 1)) : createCommentVNode("", true)
            ])) : createCommentVNode("", true),
            createElementVNode("div", _hoisted_85, [
              createElementVNode("div", _hoisted_86, [
                _cache[4] || (_cache[4] = createElementVNode("div", null, "___________________", -1)),
                createElementVNode("div", null, toDisplayString(unref(t)("invoice.delivered_by")), 1)
              ]),
              createElementVNode("div", _hoisted_87, [
                _cache[5] || (_cache[5] = createElementVNode("div", null, "___________________", -1)),
                createElementVNode("div", null, toDisplayString(unref(t)("invoice.received_by")), 1)
              ])
            ])
          ]),
          createElementVNode("div", _hoisted_88, [
            __props.order.getToPay().toUnit() > 0 ? (openBlock(), createElementBlock("div", _hoisted_89, [
              createElementVNode("p", null, toDisplayString(unref(t)("receipt.payments.to_pay_sale")) + ":", 1),
              createElementVNode("p", _hoisted_90, toDisplayString(__props.order.getToPay().abs().toFormat(priceFormat)), 1)
            ])) : (openBlock(), createElementBlock("div", _hoisted_91, [
              createElementVNode("p", null, toDisplayString(unref(t)("receipt.payments.to_pay_refund")) + ":", 1),
              createElementVNode("p", _hoisted_92, toDisplayString(__props.order.getToPay().abs().toFormat(priceFormat)), 1)
            ])),
            (openBlock(true), createElementBlock(Fragment, null, renderList(paymentTypes.value, (paymentType, index) => {
              return openBlock(), createElementBlock("div", {
                key: index,
                class: "summary-item"
              }, [
                createElementVNode("p", null, toDisplayString(paymentType.display) + ":", 1),
                createElementVNode("p", _hoisted_93, toDisplayString(unref(Money).parse(paymentType.amount).abs().toFormat(priceFormat)), 1)
              ]);
            }), 128)),
            createElementVNode("table", _hoisted_94, [
              createElementVNode("tbody", null, [
                createElementVNode("tr", _hoisted_95, [
                  createElementVNode("td", _hoisted_96, toDisplayString(unref(t)("receipt.taxes.label")), 1),
                  createElementVNode("td", _hoisted_97, toDisplayString(unref(t)("receipt.taxes.name")), 1),
                  createElementVNode("td", _hoisted_98, toDisplayString(unref(t)("receipt.taxes.rate")), 1),
                  createElementVNode("td", _hoisted_99, toDisplayString(unref(t)("receipt.taxes.amount")), 1)
                ]),
                (openBlock(true), createElementBlock(Fragment, null, renderList(__props.order.taxes, (taxItem, index) => {
                  return openBlock(), createElementBlock("tr", { key: index }, [
                    createElementVNode("td", _hoisted_100, toDisplayString(taxItem.label), 1),
                    createElementVNode("td", _hoisted_101, toDisplayString(taxItem.name), 1),
                    createElementVNode("td", _hoisted_102, toDisplayString(taxItem.rate) + "%", 1),
                    createElementVNode("td", _hoisted_103, toDisplayString(taxItem.getValue().abs().toFormat(priceFormat)), 1)
                  ]);
                }), 128)),
                ((_t = __props.venue) == null ? void 0 : _t.wholesale) ? (openBlock(), createElementBlock("tr", _hoisted_104, [
                  createElementVNode("td", _hoisted_105, toDisplayString(unref(t)("receipt.taxes.total_price_before_tax")) + ": ", 1),
                  createElementVNode("td", _hoisted_106, toDisplayString(summary.value.totalPriceBeforeTax.toFormat(priceFormat)), 1)
                ])) : createCommentVNode("", true),
                createElementVNode("tr", _hoisted_107, [
                  createElementVNode("td", _hoisted_108, toDisplayString(unref(t)("receipt.taxes.total")) + ": ", 1),
                  createElementVNode("td", _hoisted_109, toDisplayString(summary.value.totalTax.toFormat(priceFormat)), 1)
                ])
              ])
            ]),
            requestsPayment ? (openBlock(), createBlock(_sfc_main$1, {
              key: 2,
              order: __props.order,
              venue: __props.venue
            }, null, 8, ["order", "venue"])) : createCommentVNode("", true)
          ])
        ])
      ]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=index4.js.map
